<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { useCanonicalTag } from './composables/useCanonicalTag';

useCanonicalTag();
</script>
